import { Grid } from "@mui/material";
import "../../../styles/trangchu.scss";
import Box from "@mui/material/Box";
import React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import assets from "../../../assets/images/assets.svg";
import tramQuanTracIcon from "../../../assets/images/tramQuanTracIcon.png";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#f1f1f163",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary
}));
export default function ThongKeTramQuanTrac({ dataThongKe }) {
  let navigate = useNavigate();
  return (
    <div container className="thongke-main">
      <Grid item xs={12}>
        <div className="thongke-component">
          <div>
            <div className="thongke-icon">
              <img
                src={tramQuanTracIcon}
                style={{ width: "35px", height: "35px" }}
              />
            </div>
          </div>
          <div>
            <div
              onClick={() => navigate("/diemtramqtmt")}
              className="thongke-number"
            >
              {dataThongKe?.tramQT}
            </div>
            <div className="thongke-title1">Trạm quan trắc</div>
          </div>
        </div>
      </Grid>
    </div>
  );
}
